import { RuleConversationAutomationType } from 'modules/analyse-automations/types/RuleConversationAutomationType';

export const conversationAutomationTaskTypeOptions: {
  label: string;
  value: RuleConversationAutomationType;
}[] = [
  {
    label: 'Score is',
    value: RuleConversationAutomationType.CONVERSATION_SCORE
  },
  {
    label: 'Conversation status is',
    value: RuleConversationAutomationType.CONVERSATION_STATUS
  },
  {
    label: 'Screening status is satisfied',
    value: RuleConversationAutomationType.CONVERSATION_MANDATORY_QUESTIONS_MET
  },
  {
    label: 'Screening status is not satisfied',
    value:
      RuleConversationAutomationType.CONVERSATION_MANDATORY_QUESTIONS_NOT_MET
  }
];
